type Keys = string | Array<any>;

const getKeys = (keys: Keys): string[] => {
  if (keys == null) {
    return [];
  }
  if (!Array.isArray(keys)) {
    return [keys];
  }
  return keys;
};

export default getKeys;
